// extracted by mini-css-extract-plugin
export default {"return":"return-message_return__ebeb8","message":"return-message_message__tUCAs"};